export default function RiichiStick({ width = 36, theme = 'light', className }) {
  const industry = theme === 'industry'
  const big = width >= 36
  const h = industry ? 6 : big ? 7 : 6
  const r = industry ? 0 : big ? 4 : 3
  const dot = industry ? 'var(--color-accent)' : '#c0392b'

  const stickStyle = {
    position: 'relative',
    display: 'inline-block',
    width: width + 'px',
    height: h + 'px',
    borderRadius: r + 'px',
    background: industry ? '#fff' : '#eeeae0',
  }
  if (industry) {
    stickStyle.border = '1px solid var(--color-neutral-400)'
  } else {
    stickStyle.boxShadow = '0 1px 2px rgba(0,0,0,0.4)'
  }

  const dotStyle = {
    position: 'absolute',
    left: Math.round(width * 0.42) + 'px',
    top: industry ? '1px' : big ? '2px' : '1.5px',
    width: (big ? 5 : 4) + 'px',
    height: (industry ? 2.5 : 3) + 'px',
    background: dot,
    borderRadius: '50%',
  }

  return (
    <span className={className} style={stickStyle}>
      <span style={dotStyle} />
    </span>
  )
}
